import { render, staticRenderFns } from "./ViewComponentLoader.vue?vue&type=template&id=32ce98a8&scoped=true&"
import script from "./ViewComponentLoader.vue?vue&type=script&lang=js&"
export * from "./ViewComponentLoader.vue?vue&type=script&lang=js&"
import style0 from "./ViewComponentLoader.vue?vue&type=style&index=0&id=32ce98a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ce98a8",
  null
  
)

export default component.exports